// Saves a PDF the API returned as base64 through a temporary anchor. The anchor stays in the document and
// the blob URL stays alive until the browser has started the download: revoking the URL and removing the
// anchor right after click() let Chrome start the download after the revoke under load and save the file
// as the blob UUID with no extension (a real Export-as-PDF click, 10-21-26 2:59 PM ET, while the API had
// returned a .pdf file name). No event tells a page the download started, so the cleanup waits a moment.
const CLEANUP_DELAY_MS = 2000;
const DEFAULT_FILE_NAME = 'document.pdf';

// The server file name, trimmed, with a .pdf suffix; the default when the server sent none.
export const pdfFileName = (fileName: string | null | undefined): string => {
    const name = (fileName ?? '').trim();
    if (!name) return DEFAULT_FILE_NAME;
    return /\.pdf$/i.test(name) ? name : `${name}.pdf`;
};

export const downloadPdfFromBase64 = async (pdfBase64: string, fileName: string, cleanupDelayMs: number = CLEANUP_DELAY_MS): Promise<void> => {
    const blob = await fetch(`data:application/pdf;base64,${pdfBase64}`).then((res) => res.blob());
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = pdfFileName(fileName);
    link.rel = 'noopener';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    window.setTimeout(() => {
        link.remove();
        URL.revokeObjectURL(url);
    }, cleanupDelayMs);
};
